<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='prod' :items='prod' sort-by='vendedor' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title.justify-center(color='success') Clientes asociados al promotor
            v-divider.mx-4(inset vertical)
            v-spacer
            v-dialog(v-model='dialog' persistent max-width='40%')
              // activa el boton para editar
              template(v-if="!read" v-slot:activator='{ on }')
                v-btn.mx-2(color='success' dark v-on='on') Agregar
              // activa el boton para ver
              template(v-else v-slot:activator='{ off }')
              v-card(color='grey_1')
                v-app-bar(dark color='primary')
                  v-toolbar-title.headline {{ formTitle }}
                v-card-text
                  v-row(dense)
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              v-select(dense outlined v-model='editedItem.idCliente' id="vendedorID" :items='idClienteArray' label='Cliente')
                v-card-actions
                  v-spacer
                  v-btn(color='error' small dark @click.native='close')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(color='success' small dark @click.native='save')
                    v-icon mdi-content-save
                    | Guardar
        template(v-if="!read" v-slot:item.action='{ item }')
          v-icon(color='error' @click='deleteItem(item)') mdi-delete
        template(v-slot:no-data)
          h1 No existen Vendedores asociados
</template>

<script>
import Api from '@/services/methods'
export default {
  props: ['p', 'prod', 'read'],
  data: () => ({
    dialog: false,
    loading: true,
    headers: [
      { text: 'Cliente', align: 'center', sortable: false, value: 'idCliente.nombre' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    vendedor: [],
    idClienteArray: [],
    editedIndex: -1,
    editedItem: {
      idCliente: ''
    },
    defaultItem: {
      idCliente: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Agregar Cliente'
        : 'Modificar Cliente'
    },
    formTitleShow () {
      return 'Información del Cliente'
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogShow (val) {
      val || this.close()
    }

  },

  created () {
    this.initialize()
  },

  methods: {

    initialize () {
      this.listarVendedores()
    },

    listarVendedores () {
      Api.get('cliente')
        .then(response => {
          this.vendedor = response.data
          this.vendedor.map(data => {
            let ve = `${data.nombre}`
            this.idClienteArray.push({ value: data._id, text: ve })
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    showItem (item) {
      this.editedIndex = this.prod.indexOf(item)
      this.editedItem = Object.assign({}, item)
    },

    deleteItem (item) {
      const index = this.prod.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres borrar?',
        text: 'No podras revertir esto',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.prod.splice(index, 1)
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    validarCampo () {
      if (
        this.editedItem.idCliente === ''
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor seleccione un vendedor '
        })
        return true
      }
      return false
    },

    save () {
      if (!this.validarCampo()) {
        const findRepetido = this.prod.find(vendedor => vendedor.idCliente?._id === this.editedItem.idCliente)
        if (!findRepetido) {
          const vendedor = this.idClienteArray.find(vendedor => vendedor.value === this.editedItem.idCliente)
          const nombre = vendedor.text
          const _id = vendedor.value
          this.editedItem.idCliente = { _id, nombre }
          this.prod.push(this.editedItem)
          this.close()
        } else {
          this.$swal({
            icon: 'info',
            title: 'El cliente ya se encuentra agregado'
          })
        }
      }
    }

  }
}
</script>
